import classNames from 'classnames'
import style from './Radio.module.scss'

const Radio = ({
  label,
  values,
  register,
  className
}) => {

  return (
    <fieldset className={classNames(style.fieldset, className)}>
      <legend className='input-label'>
        {label}
      </legend>

      {values.map( (value) =>
        <label className={style.label} key={`radio-${value.value}`}>
          <input
            name={label ?? 'radio'}
            value={value.value}
            type='radio'
            {...register}
          />
          {value.text}
        </label>
      )}
    </fieldset>
  );
};

export default Radio;